import { Outlet } from 'react-router-dom'
import { useAuthStore } from '../../hooks/useAuth'
import { LogOut, Factory } from 'lucide-react'
import { Suspense } from 'react'

function ContentLoader() {
  return (
    <div className="flex-1 flex items-center justify-center py-24">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-4 border-aqua-200 border-t-aqua-500 rounded-full animate-spin" />
        <p className="text-sm text-gray-400 font-semibold">Cargando...</p>
      </div>
    </div>
  )
}

export default function ProduccionLayout() {
  const { user, logout } = useAuthStore()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-aqua-500 text-white px-5 py-4 flex items-center justify-between shadow-md">
        <div className="flex items-center gap-3">
          <div className="bg-white/20 p-2 rounded-xl">
            <Factory size={20} />
          </div>
          <div>
            <div className="font-bold text-base leading-tight">Producción</div>
            <div className="text-xs text-white/60 font-semibold">Bodega Toro</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <div className="text-sm font-bold">{user?.nombre}</div>
            <div className="text-xs text-white/60">Operario</div>
          </div>
          <div className="w-9 h-9 rounded-full bg-white/20 border-2 border-white/30 flex items-center justify-center font-bold text-sm flex-shrink-0">
            {user?.nombre?.slice(0, 2).toUpperCase()}
          </div>
          <button onClick={logout} className="p-2 hover:bg-white/15 rounded-xl transition-colors" title="Cerrar sesión">
            <LogOut size={18} />
          </button>
        </div>
      </header>
      <main className="flex-1 p-4 md:p-6 max-w-lg mx-auto w-full">
        <Suspense fallback={<ContentLoader />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
